"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { pathSegments } from "./path-slug-core";
export { pathSegments };

// Hook untuk kasus umum: ambil satu segmen path pada posisi `index`.
// Contoh: /order/[productSlug] → usePathSegment(1).
// Kenapa bukan useParams(): lihat path-slug-core.ts / apps/web/CLAUDE.md.
export function usePathSegment(index, t0) {
  const $ = _c(4);
  const fallback = t0 === undefined ? "_" : t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== fallback || $[1] !== index || $[2] !== pathname) {
    t1 = pathSegments(pathname)[index] ?? fallback;
    $[0] = fallback;
    $[1] = index;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}